import React, { useEffect, useState } from "react";
import moment from "moment";
import {
  Button,
  Col,
  DatePicker,
  Form,
  Icon,
  Input,
  notification,
  Row,
  Spin,
  Upload,
} from "antd";
import DividerBlock from "../../divider-block";
import SelectField from "../../select-field";
import { trailService } from "../../../services";
import ModalCreateDriver from "../create-driver";
import FieldBlock from "../../field-block";
import i18n from '../../../i18n';

export default function StepCheckingAndEditVerifiedInfo({
  id,
  driverId,
  onCheckingRequest,
  onSaveEditingInfoRequest,
  setButtonsModal,
  currentModalStep,
  setModalStep,
  loadingMessage = i18n.t('main.loadText.check'),
  carryingCapacityValues,
  isNeedChecking = true,
  onCloseModal,
}) {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [invalidFields, setInvalidFields] = useState([]);
  const [valuesInvalidFields, setValuesInvalidFields] = useState({});
  const [errorsInvalidFields, setErrorsInvalidFields] = useState({});
  const [carrying, setCarrying] = useState(0);
  const [capacity, setCapacity] = useState(null);
  const [carryingCapacity, setCarryingCapacity] = useState(null);
  const [trailTypes, setTrailTypes] = useState(null);
  const [blockedFields, setBlockedFields] = useState(null);
  const [defaultData, setDefaultData] = useState(null);
  const [isNeedUpdateList, setIsNeedUpdateList] = useState(null);

  let bigButtonStyle = {
    width: "200px",
    height: "43px",
    background: "#1CAA53",
    position: "static",
    borderRadius: "10px",
    color: "white",
    borderColor: "transparent",
  };
  let bigButtonStyleEmpty = {
    width: "200px",
    height: "43px",
    background: "#BE1C1C",
    position: "static",
    borderRadius: "10px",
    color: "white",
    borderColor: "transparent",
  };
  let dividerStyle = {
    margin: "15px 0px 45px 0px",
    display: "block",
    clear: "both",
    width: "100%",
    minWidth: "100%",
    height: "1px",
  };

  const compare = (a, b) => {
    return parseInt(a) - parseInt(b);
  };

  if (!carryingCapacity && carryingCapacityValues) {
    let carryingArr = Object.keys(carryingCapacityValues).sort(compare),
      capacityArr = carryingCapacityValues[carryingArr[0]];
    setCarrying(carryingArr);
    setCapacity(capacityArr);
    setCarryingCapacity(carryingCapacityValues);
  }

  /**
   * Открытие шага
   */
  useEffect(() => {
    setValuesInvalidFields({});
    setErrorsInvalidFields({});
    setButtonsModal(null);
    setLoading(true);

    setTimeout(() => {
      if (!isNeedChecking) {
        setModalStep(currentModalStep + 1);
        return null;
      }
      onCheckingRequest(id, driverId)
        .then((response) => {
          let defaultInvalidFields = response.data
            ? Object.assign({}, response.data)
            : {};

          if (response.blockedFields) {
            response.blockedFields.forEach((item) => {
              if (
                item === "scanDriverLicense1" ||
                item === "scanDriverLicense2" ||
                item === "scanPassportHomePage" ||
                item === "scanPassportRegPage"
              ) {
                delete defaultInvalidFields[item];
              }
            });
          }

          setLoading(false);
          setValuesInvalidFields(defaultInvalidFields);
          setErrorsInvalidFields({});
          setBlockedFields(response.blockedFields);
          setDefaultData(response.data);

          if (response.status === "success") {
            notification.success({
              message: i18n.t('components.notification.titles.onCheckingRequest'),
              description: response.message,
            });
            if (currentModalStep !== 2) {
              setModalStep(currentModalStep + 1);
            }
          } else if (response.status === "error") {
            setInvalidFields(response.fields);
          }
        })
        .catch((error) => {
          setLoading(false);
          setErrorMessage(error);
        });

      return () => {
        setValuesInvalidFields({});
        setErrorsInvalidFields({});
      };
    }, 1000);

    if (currentModalStep === 3 || currentModalStep === 4) {
      trailService
        .getTrailTypes()
        .then((response) => {
          setLoading(false);
          setTrailTypes(response);
          setValuesInvalidFields({
            ...valuesInvalidFields,
            type: setTrailTypes[0],
          });
        })
        .catch((error) => {
          notification.error({
            message: "Получение списка типов кузова",
            description: error,
          });

          setLoading(false);
        });
    }
  }, []);

  if (errorMessage) {
    return (
      <Col span={24} className="steps-checking-verified-info__error-response">
        <span>{errorMessage}</span>
      </Col>
    );
  }

  if (invalidFields.length || currentModalStep === 2) {
    /**
     * Сохранение отредактированных данных
     */
    const onSaveEditingInfo = () => {
      setLoading(true);
      if (valuesInvalidFields.scanPassportHomePage === "") {
        notification.error({
          message: i18n.t('modals.modalAttachDriverOrderDelivery.errors.scanPassportHomePage'),
          description: "",
        });
        setLoading(false);
        return false;
      }
      if (valuesInvalidFields.scanPassportRegPage === "") {
        notification.error({
          message: i18n.t('modals.modalAttachDriverOrderDelivery.errors.scanPassportHomePage'),
          description: "",
        });
        setLoading(false);
        return false;
      }

      if (valuesInvalidFields.scanDriverLicense1 === "") {
        notification.error({
          message: i18n.t('modals.modalAttachDriverOrderDelivery.errors.scanDriverLicense1'),
          description: "",
        });
        setLoading(false);
        return false;
      }
      if (valuesInvalidFields.scanDriverLicense2 === "") {
        notification.error({
          message: i18n.t('modals.modalAttachDriverOrderDelivery.errors.scanDriverLicense2'),
          description: "",
        });
        setLoading(false);
        return false;
      }
      onSaveEditingInfoRequest(id, valuesInvalidFields)
        .then((response) => {
          setLoading(false);
          if (response.status === "success") {
            notification.success({
              message: i18n.t('components.notification.titles.saveFormRequest'),
              description: response.message,
            });
            setModalStep(currentModalStep + 1);
          } else if (response.status === "error") {
            setErrorsInvalidFields(response.errors);
            Object.keys(response.errors).forEach((item) => {
              response.errors[item].forEach((message) => {
                notification.error({
                  message: i18n.t('components.notification.titles.saveFormRequest'),
                  description: message,
                });
              });
            });
          }
        })
        .catch((error) => {
          setLoading(false);
          setErrorMessage(error);
        });
    };

    /**
     * Поиск ошибок
     * -----
     * @param   {string}    nameField
     * @returns {string|null}
     */
    const getFieldErrors = (nameField) => {
      return errorsInvalidFields &&
        typeof errorsInvalidFields[nameField] !== "undefined"
        ? errorsInvalidFields[nameField][0]
        : null;
    };

    setButtonsModal([
      <Button
        htmlType="button"
        key="close"
        className={loading ? "disabled" : null}
        onClick={
          !loading
            ? () => {
                onCloseModal();
              }
            : null
        }
        style={bigButtonStyleEmpty}
      >
        {i18n.t('main.buttons.close')}
      </Button>,
      <Button
        htmlType="button"
        key="next"
        type="primary"
        className={loading ? "disabled" : null}
        onClick={!loading ? onSaveEditingInfo : null}
        style={bigButtonStyle}
      >
        {i18n.t('main.buttons.save')}
      </Button>,
    ]);

    if (!valuesInvalidFields.length) {
      for (let key in invalidFields) {
        if (invalidFields.hasOwnProperty(key)) {
          const nameField = invalidFields[key].name;
          if (typeof valuesInvalidFields[nameField] === "undefined") {
            valuesInvalidFields[nameField] = null;
          }
        }
      }
    }

    let wasInvalidCarryingCapacityTrailError = false;
    let wasInvalidCarryingCapacityTruckError = false;

    const textInvalidFields = invalidFields
      .filter((itemField) => itemField.type !== "file")
      .map((itemField, index) => {
        const errorsField = getFieldErrors(itemField.name);
        const fieldErrorProps = errorsField
          ? { validateStatus: "error", help: errorsField }
          : {};
        switch (itemField.type) {
          case "text":
            return (
              <Form.Item {...fieldErrorProps}>
                <Row gutter={[12, 24]}>
                  <Col lg={24} md={24} sm={24} xs={24} key={itemField.name}>
                    <div className="form-field-label">{itemField.title}</div>
                  </Col>
                </Row>
                <Col lg={24} md={24} sm={24} xs={24}>
                  <Input
                    name={itemField.name}
                    value={valuesInvalidFields[itemField.name]}
                    onChange={(e) => {
                      setValuesInvalidFields({
                        ...valuesInvalidFields,
                        [itemField.name]: e.target.value,
                      });
                    }}
                  />
                </Col>
              </Form.Item>
            );

          case "selectCountryDriver":
            return (
              <Form.Item {...fieldErrorProps}>
                <Row gutter={[12, 24]}>
                  <Col lg={24} md={24} sm={24} xs={24} key={itemField.name}>
                    <div className="form-field-label">{itemField.title}</div>
                  </Col>
                </Row>
                <Row gutter={[12, 24]}>
                  <Col lg={12} md={24} sm={24} xs={24}>
                    <SelectField
                      name={itemField.name}
                      selectedValue={valuesInvalidFields[itemField.name]}
                      values={[
                        { Id: "Россия", Name: i18n.t('constants.countries.1') },
                        { Id: "Другая страна", Name: i18n.t('constants.countries.4') },
                      ]}
                      onChange={(e) => {
                        setValuesInvalidFields({
                          ...valuesInvalidFields,
                          [itemField.name]: e,
                        });
                      }}
                      getErrors={getFieldErrors}
                      style={{ width: "100%" }}
                    />
                  </Col>
                  <Col lg={12} md={24} sm={24} xs={24}>
                    <span className="form-field-label">{i18n.t('modals.modalAttachDriverOrderDelivery.form.passportSerial.label')}</span>
                    <Input
                      name="passport_serial"
                      value={valuesInvalidFields.passport_serial}
                      onChange={(e) => {
                        setValuesInvalidFields({
                          ...valuesInvalidFields,
                          passport_serial: e.target.value,
                        });
                      }}
                    />
                  </Col>
                  <Col lg={12} md={24} sm={24} xs={24}>
                    <span className="form-field-label">{i18n.t('modals.modalAttachDriverOrderDelivery.form.passportNumber.label')}</span>
                    <Input
                      name="passport_number"
                      value={valuesInvalidFields.passport_number}
                      onChange={(e) => {
                        setValuesInvalidFields({
                          ...valuesInvalidFields,
                          passport_number: e.target.value,
                        });
                      }}
                    />
                    <span className="form-field-label">
                      {i18n.t('modals.modalAttachDriverOrderDelivery.form.driverLicenseSerial.label')}
                    </span>
                    <Input
                      name="driver_license_serial"
                      value={valuesInvalidFields.driver_license_serial}
                      onChange={(e) => {
                        setValuesInvalidFields({
                          ...valuesInvalidFields,
                          driver_license_serial: e.target.value,
                        });
                      }}
                    />
                  </Col>
                  <Col lg={12} md={24} sm={24} xs={24}>
                    <span className="form-field-label">
                      {i18n.t('modals.modalAttachDriverOrderDelivery.form.driverLicenseNumber.label')}
                    </span>
                    <Input
                      name="driver_license_number"
                      value={valuesInvalidFields.driver_license_number}
                      onChange={(e) => {
                        setValuesInvalidFields({
                          ...valuesInvalidFields,
                          driver_license_number: e.target.value,
                        });
                      }}
                    />
                  </Col>
                </Row>
              </Form.Item>
            );

          case "selectCountryTruck":
            return (
              <Form.Item {...fieldErrorProps}>
                <Row gutter={[12, 24]}>
                  <Col lg={12} md={24} sm={24} xs={24}>
                    <span className="form-field-label">{itemField.title}</span>
                    <SelectField
                      name={itemField.name}
                      selectedValue={valuesInvalidFields[itemField.name]}
                      values={[
                        { Id: "Россия", Name: i18n.t('constants.countries.1') },
                        { Id: "Другая страна", Name: i18n.t('constants.countries.4') },
                      ]}
                      onChange={(e) => {
                        setValuesInvalidFields({
                          ...valuesInvalidFields,
                          [itemField.name]: e,
                        });
                      }}
                      getErrors={getFieldErrors}
                      style={{ width: "100%" }}
                    />
                  </Col>
                  <Col lg={12} md={24} sm={24} xs={24}>
                    <span className="form-field-label">{i18n.t('modals.modalAttachDriverOrderDelivery.form.truckNumber.label')}</span>
                    <Input
                      name="number"
                      value={valuesInvalidFields.number || ""}
                      onChange={(e) => {
                        setValuesInvalidFields({
                          ...valuesInvalidFields,
                          number: e.target.value,
                        });
                      }}
                      getErrors={getFieldErrors}
                    />
                  </Col>
                </Row>
              </Form.Item>
            );

          case "selectCountryTrail":
            return (
              <Form.Item {...fieldErrorProps}>
                <Row gutter={[12, 24]}>
                  <Col lg={24} md={24} sm={24} xs={24} key={itemField.name}>
                    <div className="form-field-label">{itemField.title}</div>
                  </Col>
                </Row>
                <Row gutter={[12, 24]}>
                  <Col lg={12} md={24} sm={24} xs={24}>
                    <SelectField
                      name={itemField.name}
                      selectedValue={valuesInvalidFields[itemField.name]}
                      values={[
                        { Id: "Россия", Name: i18n.t('constants.countries.1') },
                        { Id: "Другая страна", Name: i18n.t('constants.countries.4') },
                      ]}
                      onChange={(e) => {
                        setValuesInvalidFields({
                          ...valuesInvalidFields,
                          [itemField.name]: e,
                        });
                      }}
                      getErrors={getFieldErrors}
                      style={{ width: "100%" }}
                    />
                  </Col>
                  <Col lg={12} md={24} sm={24} xs={24}>
                    <span className="form-field-label">{i18n.t('modals.modalAttachDriverOrderDelivery.form.trailNumber.label')}</span>
                    <Input
                      name="number"
                      value={valuesInvalidFields.number || ""}
                      onChange={(e) => {
                        setValuesInvalidFields({
                          ...valuesInvalidFields,
                          number: e.target.value,
                        });
                      }}
                    />
                  </Col>
                </Row>
              </Form.Item>
            );

          case "date":
            const dateValue = valuesInvalidFields[itemField.name]
              ? moment(valuesInvalidFields[itemField.name])
              : null;

            return (
              <Form.Item {...fieldErrorProps}>
                <Row gutter={[12, 24]}>
                  <Col lg={24} md={24} sm={24} xs={24} key={itemField.name}>
                    <div className="form-field-label">{itemField.title}</div>
                  </Col>
                </Row>
                <Col lg={24} md={24} sm={24} xs={24} key={itemField.name}>
                  <DatePicker
                    style={{ width: "100%", height: "40px" }}
                    defaultValue={dateValue}
                    format="DD.MM.YYYY"
                    size="large"
                    name={itemField.name}
                    allowClear={false}
                    onChange={(date) => {
                      setValuesInvalidFields({
                        ...valuesInvalidFields,
                        [itemField.name]: date.format("YYYY-MM-DD"),
                      });
                    }}
                  />
                </Col>
              </Form.Item>
            );

          case "invalidCarryingCapacityTrail":
            if (!wasInvalidCarryingCapacityTrailError) {
              wasInvalidCarryingCapacityTrailError = true;
              return (
                <Form.Item {...fieldErrorProps}>
                  <Row gutter={[12, 24]}>
                    <Col
                      lg={24}
                      md={24}
                      sm={24}
                      xs={24}
                      key={itemField.name + index}
                    >
                      <span className="form-field-label">{`${itemField.title} ${i18n.t('modals.modalAttachDriverOrderDelivery.genitiveTrail')}`}</span>
                    </Col>
                  </Row>
                  <Row gutter={[12, 24]}>
                    <Col
                      lg={12}
                      md={24}
                      sm={24}
                      xs={24}
                      key={itemField.name + index}
                    >
                      <SelectField
                        showSearch={false}
                        title={i18n.t('modals.modalAttachDriverOrderDelivery.form.carrying.title')}
                        name="carrying"
                        selectedValue={valuesInvalidFields.carrying}
                        values={carrying}
                        onChange={(e) => {
                          setCapacity(carryingCapacityValues[e]);
                          setValuesInvalidFields({
                            ...valuesInvalidFields,
                            carrying: e,
                          });
                        }}
                        getErrors={getFieldErrors}
                        style={{ width: "100%" }}
                      />
                    </Col>
                    <Col
                      lg={12}
                      md={24}
                      sm={24}
                      xs={24}
                      key={itemField.name + index}
                    >
                      <SelectField
                        showSearch={false}
                        title={i18n.t('modals.modalAttachDriverOrderDelivery.form.capacity.title')}
                        name="capacity"
                        selectedValue={valuesInvalidFields.capacity}
                        values={capacity}
                        onChange={(e) => {
                          setValuesInvalidFields({
                            ...valuesInvalidFields,
                            capacity: e,
                          });
                        }}
                        getErrors={getFieldErrors}
                        style={{ width: "100%" }}
                      />
                    </Col>
                  </Row>
                </Form.Item>
              );
            } else {
              return null;
            }

          case "invalidCarryingCapacityTruck":
            if (!wasInvalidCarryingCapacityTruckError) {
              wasInvalidCarryingCapacityTruckError = true;
              return (
                <Form.Item {...fieldErrorProps}>
                  <Row gutter={[12, 24]}>
                    <Col
                      lg={24}
                      md={24}
                      sm={24}
                      xs={24}
                      key={itemField.name + index}
                    >
                      <span className="form-field-label">{`${itemField.title} ${i18n.t('modals.modalAttachDriverOrderDelivery.genitiveTruck')}`}</span>
                    </Col>
                  </Row>
                  <Row gutter={[12, 24]}>
                    <Col
                      lg={12}
                      md={24}
                      sm={24}
                      xs={24}
                      key={itemField.name + index}
                    >
                      <SelectField
                        showSearch={false}
                        title={i18n.t('modals.modalAttachDriverOrderDelivery.form.carrying.title')}
                        name="carrying"
                        selectedValue={valuesInvalidFields.carrying}
                        values={carrying}
                        onChange={(e) => {
                          setCapacity(carryingCapacityValues[e]);
                          setValuesInvalidFields({
                            ...valuesInvalidFields,
                            carrying: e,
                          });
                        }}
                        getErrors={getFieldErrors}
                        style={{ width: "100%" }}
                      />
                    </Col>
                    <Col
                      lg={12}
                      md={24}
                      sm={24}
                      xs={24}
                      key={itemField.name + index}
                    >
                      <SelectField
                        showSearch={false}
                        title={i18n.t('modals.modalAttachDriverOrderDelivery.form.capacity.title')}
                        name="capacity"
                        selectedValue={valuesInvalidFields.capacity}
                        values={capacity}
                        onChange={(e) => {
                          setValuesInvalidFields({
                            ...valuesInvalidFields,
                            capacity: e,
                          });
                        }}
                        getErrors={getFieldErrors}
                        style={{ width: "100%" }}
                      />
                    </Col>
                  </Row>
                </Form.Item>
              );
            } else {
              return null;
            }

          case "selectCarcassType":
            return (
              <Form.Item {...fieldErrorProps}>
                <Row gutter={[12, 24]}>
                  <Col lg={24} md={24} sm={24} xs={24}>
                    <div className="form-field-label">{itemField.title}</div>
                    <SelectField
                      name="type"
                      title=""
                      values={trailTypes}
                      selectedValue={valuesInvalidFields.type}
                      onChange={(e) => {
                        setValuesInvalidFields({
                          ...valuesInvalidFields,
                          type: e,
                        });
                      }}
                      getErrors={getFieldErrors}
                      style={{ width: "100%" }}
                    />
                  </Col>
                </Row>
              </Form.Item>
            );

          default:
            return (
              <Row gutter={[12, 24]}>
                <Col
                  lg={24}
                  md={24}
                  sm={24}
                  xs={24}
                  key={itemField.name + index}
                  style={{
                    textAlign: "center",
                    color: "#d46f61",
                    fontSize: "10pt",
                    paddingTop: "30px",
                  }}
                >
                  <span>
                    {i18n.t('modals.modalAttachDriverOrderDelivery.errors.undefined')} "{itemField.title}"
                  </span>
                </Col>
              </Row>
            );
        }
      });

    const scansInvalidFields = invalidFields
      .filter((itemField) => itemField.type === "file")
      .map((itemField) => {
        const errorsField = getFieldErrors(itemField.name);
        const fieldErrorProps = errorsField
          ? { validateStatus: "error", help: errorsField }
          : {};

        const uploaderProps = {
          multiple: false,
          disabled: valuesInvalidFields[itemField.name] !== null,
          showUploadList: true,
          onRemove: () => {
            setValuesInvalidFields({
              ...valuesInvalidFields,
              [itemField.name]: null,
            });
          },
          beforeUpload: (file) => {
            setValuesInvalidFields({
              ...valuesInvalidFields,
              [itemField.name]: file,
            });
            return false;
          },
        };
        return (
          <Col
            lg={12}
            md={24}
            sm={24}
            xs={24}
            key={itemField.name}
            style={{ padding: "10px" }}
          >
            <Form.Item {...fieldErrorProps}>
              <FieldBlock getErrors={getFieldErrors}>
                <Upload
                  defaultFileList={[]}
                  showUploadList={{ showRemoveIcon: true }}
                  listType="picture"
                  className="single-btn-upload"
                  {...uploaderProps}
                >
                  <Button htmlType="button">
                    <svg
                      width="17"
                      height="22"
                      viewBox="0 0 17 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="download-file-svg"
                    >
                      <path
                        d="M11.5631 0.165835C11.4647 0.0622087 11.3298 0 11.19 0H2.81953C1.27495 0 0 1.26988 0 2.81429V18.643C0 20.1875 1.27495 21.4574 2.81953 21.4574H14.1805C15.725 21.4574 17 20.1875 17 18.643V6.07435C17 5.93962 16.9378 5.81013 16.8497 5.71158L11.5631 0.165835ZM11.7134 1.82959L15.2534 5.54574H12.9522C12.268 5.54574 11.7134 4.99634 11.7134 4.31221V1.82959ZM14.1805 20.4208H2.81953C1.85038 20.4208 1.03659 19.6175 1.03659 18.643V2.81429C1.03659 1.84514 1.84514 1.03659 2.81953 1.03659H10.6768V4.31221C10.6768 5.57161 11.6928 6.58233 12.9522 6.58233H15.9634V18.643C15.9634 19.6175 15.1549 20.4208 14.1805 20.4208Z"
                        fill="#1CAA53"
                      ></path>
                      <path
                        d="M12.7642 16.8447H4.23314C3.94813 16.8447 3.71484 17.0778 3.71484 17.363C3.71484 17.648 3.94813 17.8813 4.23314 17.8813H12.7695C13.0545 17.8813 13.2878 17.648 13.2878 17.363C13.2878 17.0778 13.0545 16.8447 12.7642 16.8447Z"
                        fill="#1CAA53"
                      ></path>
                      <path
                        d="M5.84741 11.268L7.9828 8.97187V14.6317C7.9828 14.9167 8.21608 15.15 8.5011 15.15C8.78627 15.15 9.01939 14.9167 9.01939 14.6317V8.97187L11.1548 11.268C11.2584 11.3767 11.3933 11.4339 11.5331 11.4339C11.6575 11.4339 11.7872 11.3872 11.8856 11.2939C12.093 11.097 12.1085 10.7704 11.9116 10.5631L8.87435 7.30304C8.7758 7.19942 8.64107 7.13721 8.49602 7.13721C8.35081 7.13721 8.21608 7.19942 8.11769 7.30304L5.08044 10.5631C4.8835 10.7704 4.89906 11.102 5.10631 11.2939C5.32404 11.4908 5.65047 11.4753 5.84741 11.268Z"
                        fill="#1CAA53"
                      ></path>
                    </svg>{" "}
                    {itemField.title}
                  </Button>
                </Upload>
              </FieldBlock>
            </Form.Item>
          </Col>
        );
      });

    return (
      <Spin
        spinning={loading}
        size="large"
        tip={i18n.t('main.loadText.process')}
      >
        <h2 className="steps-checking-verified-info__header">
          {i18n.t('modals.modalAttachDriverOrderDelivery.errors.title')}
        </h2>
        {currentModalStep === 2 ? (
          <ModalCreateDriver
            editing={true}
            valuesInvalidFields={valuesInvalidFields}
            setValuesInvalidFields={setValuesInvalidFields}
            blockedFields={blockedFields}
            defaultFieldErrors={invalidFields}
            defaultFieldsData={defaultData}
            errorsInvalidFields={errorsInvalidFields}
            setIsNeedUpdateList={setIsNeedUpdateList}
          />
        ) : (
          <Form>
            {textInvalidFields}
            {typeof scansInvalidFields !== "undefined" &&
            scansInvalidFields !== null &&
            scansInvalidFields.length ? (
              <div>
                <span className="divider-label">
                  {i18n.t('modals.modalAttachDriverOrderDelivery.errors.scans')}
                </span>
                <DividerBlock style={dividerStyle} />
              </div>
            ) : null}
            {scansInvalidFields}
          </Form>
        )}
      </Spin>
    );
  }

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "20px" }}>
        <Spin spinning={loading} size="large" tip={loadingMessage} />
      </div>
    );
  }

  return <div />;
}
